export default __webpack_public_path__ + "static/O0234-1f08fb62a6c11ca9949eecbbd9c798bc.png";